export default __webpack_public_path__ + "static/media/IMG_8642.774b8cf6.JPG";